module.exports = __webpack_public_path__ + "assets/images/sizeofboat-02.44b2dd24168a0fe9e4ddeef1838b4c54.svg";